<script setup>
import {computed, onMounted, watch} from 'vue'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'

const store = useStore()
const router = useRouter()
const route = useRoute()

const orgs = computed(() => store.getters['org/getOrgs'])

const redirectToSelectedOrg = async () => {
  // Skip redirect if we're already on an organization route
  if (route.name === 'OrgProjects' || route.name === 'OrgLayers') {
    return
  }

  const orgId = await store.dispatch('org/resolveSelectedOrg')
  if (orgId) {
    router.replace({ name: 'OrgProjects', params: { org_id: orgId } })
  }
}

onMounted(redirectToSelectedOrg)

// Landing here on a hard refresh can beat the auth flow's org fetch, in which case
// the mount-time attempt finds nothing. Retry once the orgs actually arrive.
watch(orgs, (newOrgs) => {
  if (newOrgs.length) redirectToSelectedOrg()
})
</script>

<template>
  <div class="flex items-center justify-center h-full">
    <div class="text-center">
      <h3 class="text-lg font-semibold">Loading...</h3>
      <p class="text-gray-500 mt-2">Redirecting to your organization</p>
    </div>
  </div>
</template>
